import Vue from 'vue';
import { useOneReachConfig } from './common';

/** We have to provide config manually since  */
export const useComponentBundles = () => {
  const HITL_BUNDLE_PREFIX = 'HITL';
  const HITL_UI_SERVICE = HITL_BUNDLE_PREFIX.toLowerCase();

  const ORConfig = useOneReachConfig().getORConfig();

  /**
   * TODO: UMD bundle expects dependencies to be in global "window"
   * and creating script puts results there as well.
   */
  const getComponentBundle = async (args: {
    key: string;
    path: string;
    version: string;
    discoveryUrl: string;
  }) => {
    try {
      const { key, path, version, discoveryUrl } = args;
      const { url } = await getDiscoveryURL({ discoveryUrl });

      (window as any).Vue = Vue;
      const bundleURL = `${url}/core/v${version}/${path}`;
      /**
       * TODO: Use this line to load local bundle!
       * const bundleURL = 'http://localhost:5500/agent-ui.umd.js';
       * useCors: true,
       */
      await getScript({ url: bundleURL, key, version, useCors: false });

      const component = (window as any)[key].default;
      delete (window as any)[key];
      return component;
    } catch (e) {
      console.debug('Error while retrieving component bundle!', e);
      throw e;
    }
  };

  const getBundleKey = (args: { key: string; version: string; }) => {
    return `${HITL_BUNDLE_PREFIX}-${args.key}-v${args.version}`;
  };

  /** In most cases we should have UI URL in the config so we won't have to make a request */
  const getDiscoveryURL = async (args: {
    discoveryUrl: string;
  }): Promise<{ url: string; }> => {
    if (ORConfig.HITL_UI_URL) {
      return { url: ORConfig.HITL_UI_URL };
    }

    const url = `${args.discoveryUrl}/api/v2?serviceName=${HITL_UI_SERVICE}`;
    const response = await fetch(url);
    return await response.json();
  };

  const getScript = async (args: {
    url: string; key: string;
    version: string;
    useCors?: boolean;
  }) => {
    if (args.useCors) {
      const script = document.createElement('script');
      script.id = getBundleKey({ key: args.key, version: args.version });
      const response = await fetch(args.url, { mode: 'cors' });
      script.src = await response.text();
      document.body.appendChild(script);
      return;
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = getBundleKey({ key: args.key, version: args.version });
      script.src = args.url;
      script.async = true;
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
    });
  };

  const cleanUpBundle = (args: { key: string; version: string; }) => {
    const script = document.querySelector(`script#${getBundleKey(args)}`);
    script?.remove();
  };

  return { getComponentBundle, getBundleKey, cleanUpBundle };
};
